import React, {PropTypes as T} from 'react';
import GeneralError from './general_error';
import LoadError from './seatmap_load_error';
import PriceTypeTicketLimitError from './pricetype_ticket_limit_error';
import MemberTicketLimitError from './member_ticket_limit_error';
import SeatsNoLongerAvailableError from './seats_no_longer_available_error';
import AvoidSingleSeat from './avoid_single_seat';
import basketActions from '../../../actions/basket';

export default class SeatmapErrors extends React.Component {
  static propTypes = {
    error: T.object,
    eventId: T.string
  };

  clearError = () => {
    basketActions.dismissError();
  };

  render () {
    let errors = null;
    if (this.props.error.errorCode) {
      switch (this.props.error.errorCode) {
        case 'LOAD_ERROR':
          errors = <LoadError {...this.props} />;
          break;
        case 'PRICE_TYPE_LIMIT_ERROR':
        case 'PASSWORD_PROTECTED_PRICE_TYPE_LIMIT_ERROR':
          errors = <PriceTypeTicketLimitError {...this.props.error} onClose={this.clearError} />;
          break;
        case 'MEMBER_LIMIT_ERROR':
          errors = <MemberTicketLimitError {...this.props.error} onClose={this.clearError} />;
          break;
        case 'NO_AVAILABILITY_ERROR':
        case 'BIGGEST_SEAT_BLOCK_ERROR':
          errors = <SeatsNoLongerAvailableError
            {...this.props.error}
            onClose={this.clearError}
            eventId={this.props.eventId} />;
          break;
        default:
          errors = <GeneralError {...this.props.error} onClose={this.clearError} />;
      }
    }

    return (
      <div>
        <AvoidSingleSeat {...this.props} />
        {errors}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/errors/index.js